<div class="wrapper" #pageWrapper>
  <router-outlet></router-outlet>
</div>
